import * as React from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import { ColorStyleProps } from '../../../@types/theme';
import Text from '../../atoms/Text';
import Icon from '../../atoms/Icon';
import Spinner from '../../atoms/Spinner';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  icon?: FontAwesomeIconProps['icon'];
  title: string;
  titleColor?: ColorStyleProps;
  loading?: boolean;
  children: React.ReactNode;
}

export const ReportField: React.FunctionComponent<Props> = ({
  className,
  icon,
  title,
  titleColor,
  loading = false,
  children,
  ...htmlElementProps
}) => (
  <div className={className} {...htmlElementProps}>
    <Text
      className="d-flex flex-items-center mb-2"
      size="sm1"
      weight="bold"
      color={titleColor}
      isUpperCase
    >
      {icon && <Icon className="mr-2" icon={icon} size="sm" color="gray300" />}
      {title}
    </Text>

    <Text as="span" color="blackLight">
      {loading && <Spinner size="xs" />}

      {children}
    </Text>
  </div>
);

export default ReportField;
